import * as React from 'react';

import { TouchButton } from '@rematter/ui-web';
import { LucideTruck } from 'lucide-react';

import { EditFreightDialog } from '../dialogs/EditFreightDialog';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type AddFreightWidgetProps = {
  onAddFreightCharge: () => void;
  buttonSize?: 'sm' | 'md' | 'lg' | 'xl';
};

//
// ⚛️ ⚛️ ⚛️ ADD FREIGHT WIDGET ⚛️ ⚛️ ⚛️
//
export const AddFreightWidget: React.FC<AddFreightWidgetProps> = ({
  onAddFreightCharge,
  buttonSize,
}) => {
  // Translations
  const t = useTranslations();

  return (
    <>
      <TouchButton
        onPress={onAddFreightCharge}
        className="@AddItemButton w-full"
        isSelected={false}
        leftElement={<LucideTruck />}
        color="primary"
        variant="outline"
        size={buttonSize}
        aria-label="Add Item"
      >
        {t.scaleTicketPro.actions.addFreight}
      </TouchButton>

      <EditFreightDialog />
    </>
  );
};
